export default __webpack_public_path__ + "static/media/Give Credit2.76a4b9a1.svg";